import { SupervisorTypes, SupervisorActionTypes } from "./supervisorTypes";
import { SupervisorResponse } from "@/main/models/response/supervisorResponse";
import { SupervisorFilterRequest } from "@/main/models/request/supervisorRequest";
import { KeyValue } from "@/main/models/common";

export function getSupervisors(
	request: SupervisorFilterRequest,
	keyReducer: string = "default",
): SupervisorActionTypes {
	return {
		type: SupervisorTypes.GET_SUPERVISOR,
		payload: {
			request,
			keyReducer,
		},
	};
}

export function getSupervisorsDomain(
	request: SupervisorFilterRequest,
	keyReducer: string = "default",
): SupervisorActionTypes {
	return {
		type: SupervisorTypes.GET_SUPERVISOR_DOMAIN,
		payload: {
			request,
			keyReducer,
		},
	};
}

export function saveSupervisorsDomain(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): SupervisorActionTypes {
	return {
		type: SupervisorTypes.SAVE_SUPERVISOR_DOMAIN,
		payload: { data, isError, errorMessages },
	};
}

export function saveSupervisors(
	data: SupervisorResponse | null,
	isError: boolean,
	errorMessages: string[] | null,
	keyReducer: string = "default",
): SupervisorActionTypes {
	return {
		type: SupervisorTypes.SAVE_SUPERVISOR,
		payload: { data, isError, errorMessages, keyReducer },
	};
}

export function resetReducerSupervisors(): SupervisorActionTypes {
	return {
		type: SupervisorTypes.RESET_REDUCER_SUPERVISOR,
	};
}
